import { useState, useEffect } from 'react';

// ── Cache store (module-level — persiste entre navegações) ────────────────────
const _store = new Map(); // key → { data, ts }
const TTL_MS = 5 * 60 * 1000; // 5 minutos

// ── Utilitários (usáveis fora de componentes React) ───────────────────────────
export function getCached(key) {
  const entry = _store.get(key);
  if (entry && Date.now() - entry.ts < TTL_MS) return entry.data;
  return null;
}

export function setCached(key, data) {
  _store.set(key, { data, ts: Date.now() });
}

export function invalidateCache(prefix = '') {
  for (const key of _store.keys()) {
    if (key.startsWith(prefix)) _store.delete(key);
  }
}

// ── Hook React ────────────────────────────────────────────────────────────────
// Uso: const { data, loading } = useCachedFetch('key', () => axios.get(...).then(r => r.data), [dep])
export function useCachedFetch(key, fetcherFn, deps = []) {
  const cached = getCached(key);
  const [data, setData]       = useState(cached);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    const hit = getCached(key);
    if (hit) {
      setData(hit);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    fetcherFn()
      .then(result => {
        if (cancelled) return;
        setCached(key, result);
        setData(result);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading };
}
